module.exports = __webpack_public_path__ + "static/together_bg2-8ce467bfb1817b771dd4be7b428a877a.png";